export default "__VITE_ASSET__9f78f55b__$_?react__"